import { LockOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { changePassword } from "API/myPages";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { useAuth } from "Hooks/useAuth";
import { useEffect, useState } from "react";

const ChangePassword = () => {
  const { openSuccess, openError } = usePopupNotificationContext();
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState({ value: "", error: "" });
  const [currentPassword, setCurrentPassword] = useState({
    value: "",
    error: "",
  });
  const [newPassword, setNewPassword] = useState({ value: "", error: "" });
  const [confirmPassword, setConfirmPassword] = useState({
    value: "",
    error: "",
  });

  const { authData } = useAuth();

  useEffect(() => {
    if (authData && authData.username) {
      setUsername({ value: authData.username, error: "" });
    }
  }, [authData]);

  const handleOnClick = async () => {
    let error = false;
    setLoading(true);
    if (newPassword.value !== confirmPassword.value) {
      setConfirmPassword({
        ...confirmPassword,
        error: "Matchar ej lösenordet",
      });
      error = true;
    }

    if (!newPassword.value) {
      setNewPassword({ ...newPassword, error: "Fält får ej vara tomt" });
      error = true;
    }

    if (!confirmPassword.value) {
      setConfirmPassword({
        ...confirmPassword,
        error: "Fält får ej vara tomt",
      });
      error = true;
    }

    if (!currentPassword.value) {
      setCurrentPassword({
        ...currentPassword,
        error: "Fält får ej vara tomt",
      });
      error = true;
    }

    if (!username.value) {
      setUsername({ ...username, error: "Fält får ej vara tomt" });
      error = true;
    }

    if (!error) {
      const res = await changePassword({
        Username: username.value,
        CurrentPassword: currentPassword.value,
        NewPassword: newPassword.value,
      });
      if (res.status === 200) {
        openSuccess(res.data, 3000);
        setTimeout(() => (window.location.href = "/mypages"), 300);
      } else {
        openError(res.data, 3000);
      }
    }
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="false">
      <Container maxWidth="xs" sx={{ pt: 15 }}>
        <Paper>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              rowGap: "25px",
              p: 2,
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlined />
            </Avatar>
            <Typography component="h1" variant="h5">
              Byt lösenord
            </Typography>
            <Box>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Epost"
                autoComplete="email"
                autoFocus
                value={username.value}
                disabled
                error={!!username.error}
                onChange={(e) =>
                  setUsername({ value: e.target.value, error: "" })
                }
                helperText={username.error}
                size="small"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                label="Nuvarande lösenord"
                type="password"
                id="password0"
                size="small"
                error={!!currentPassword.error}
                value={currentPassword.value}
                helperText={currentPassword.error}
                onChange={(e) =>
                  setCurrentPassword({ value: e.target.value, error: "" })
                }
              />
              <Divider sx={{ marginY: "10px" }} />
              <TextField
                margin="normal"
                required
                fullWidth
                label="Nytt lösenord"
                type="password"
                id="password1"
                size="small"
                error={!!newPassword.error}
                value={newPassword.value}
                helperText={newPassword.error}
                onChange={(e) =>
                  setNewPassword({ value: e.target.value, error: "" })
                }
              />
              <TextField
                margin="normal"
                required
                fullWidth
                label="Bekräfta lösenord"
                type="password"
                id="password2"
                autoComplete="current-password"
                size="small"
                error={!!confirmPassword.error}
                value={confirmPassword.value}
                helperText={confirmPassword.error}
                onChange={(e) =>
                  setConfirmPassword({ value: e.target.value, error: "" })
                }
              />

              <LoadingButton
                fullWidth
                variant="contained"
                loading={loading}
                sx={{ mt: 4, mb: 1.5 }}
                onClick={handleOnClick}
              >
                Byt lösenord
              </LoadingButton>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Container>
  );
};

export default ChangePassword;
